import objectUtils from '../utils/object-utils'

export default class OrderConfirmationCode {
  constructor (options = {}) {
    this.model = 'OrderConfirmationCode'

    this.id = objectUtils.get(options, 'id', null)
    this.org_id = objectUtils.get(options, 'org_id', null)
    this.order_id = objectUtils.get(options, 'order_id', null)
    this.confirmation_code = objectUtils.get(options, 'confirmation_code', null)

    // Auditing
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)
  }
}
